app.service('partnerSubscriptionManager', function (message, broker, modal, loading, log) {

	let productId;
	let productPlu;
	let savedServices = [];
	let relatedPromotionIdentifier;
	let $checkboxes, $checkboxAndSelects, $confirm;

	function load(params) {
		productId = params.product;
		productPlu = params.productPlu;
		relatedPromotionIdentifier = params.relatedPromotionIdentifier;
		savedServices = params.added;
		loading.start();
		$.ajax({
			url: '/cart-partner-subscriptions.ltr',
			data: {
				productId,
				partnerSubscriptionGroupId: params.group,
				relatedPromotionIdentifier
			},
			success: function (html) {
				loading.stop();
				modal.generate({
					content: html,
					modifier: 'remodal-full-width',
					id: 'modal-partner-subscriptions',
					callbackOpen: function () {
						$checkboxes = $('#modal-partner-subscriptions input:checkbox');
						$checkboxAndSelects = $('#modal-partner-subscriptions').find('.js-partner-service-quantity, input:checkbox');
						$confirm = $('#modal-partner-subscriptions .js-partner-subscription-save');
						$('#modal-partner-subscriptions .js-partner-subscription-change-more').click(function (event) {
							$(this).closest('.partner-subscription-item').toggleClass('extended');
							event.stopPropagation();
							event.preventDefault();
						});
						$checkboxAndSelects.change(() => {
							$confirm.removeAttr('disabled');
						});
						$confirm.click(function () {
							save();
							modal.close();
						});
					}
				})
			},
			error: function () {
				modal.alert('Błąd pobierania danych');
			}
		});
	}

	function save() {
		const toAddList = [];
		const toRemoveList = [];
		const toUpdateList = [];
		function checkPrevQuantity(value) {
			const prevQuantity = savedServices.filter(service => service.id == value);
			return prevQuantity.length ? prevQuantity[0].quantity : 0;
		}

		function removeSelected() {
			const item = toRemoveList.shift();
			log.event({
				id: 'remove_cart',
				f03: 'cart_step_1',
				f04: item,
				f05: 'service',
				f06: productPlu,
				f07: 'service_details',
				f08: 'fancybox',
				f09: 'new',
				f10: 'subscription'
			});
			update('remove', {
				productId,
				relatedPromotionIdentifier,
				partnerSubscriptionId: item
			}, function () {
				run();
			})
		}

		function addSelected() {
			const item = toAddList.shift();
			log.event({
				id: 'to_cart',
				f03: 'cart_step_1',
				f04: item.serviceId * 1,
				f05: 'service',
				f06: productPlu,
				f07: 'services_details',
				f08: 'fancybox',
				f09: 'new',
				f10: 'subscription'
			});
			update('add', {
				productId,
				relatedPromotionIdentifier,
				partnerSubscriptionId: item.serviceId,
				quantity: item.quantity
			}, function () {
				run();
			});
		}

		function updateSelected() {
			const item = toUpdateList.shift();
			update('change', {
				productId,
				relatedPromotionIdentifier,
				partnerSubscriptionId: item.serviceId,
				quantity: item.quantity
			}, function () {
				run();
			});
		}

		function endSelected() {
			modal.close();
			broker.trigger('REFRESH_BASKET_VIEW');
		}

		function run() {
			if (toRemoveList.length) {
				removeSelected();
			} else if (toUpdateList.length) {
				updateSelected();
			} else if (toAddList.length) {
				addSelected();
			} else {
				endSelected();
			}
		}

		function update(action, options) {
			let url = '';
			if (action == 'remove') {
				url = '/remove-partner-subscription.ltr';
			} else if (action == 'change') {
				url = '/cart-update-partner-subscription-quantity.ltr';
			} else if (action == 'add') {
				url = '/add-partner-subscriptions-to-cart.ltr';
			}
			$.ajax({
				url: url,
				type: 'POST',
				data: options,
				cache: false,
				success: function (json) {
					if (json.status == 'SUCCESS') {
						run();
					} else if (json.status == 'FAIL') {
						let failMessage = json.messages;
						if (failMessage && typeof (failMessage) === 'object') {
							failMessage = failMessage[0];
						}
						if (failMessage.startsWith('msg:')) {
							message.alert(failMessage, function () {
								broker.trigger('REFRESH_BASKET_VIEW');
							});
						} else {
							modal.alert(failMessage, function () {
								broker.trigger('REFRESH_BASKET_VIEW');
							});
						}
					} else {
						modal.alert('Nieznany błąd przy usługach partnerskich', function () {
							broker.trigger('REFRESH_BASKET_VIEW');
						});
					}
				},
				error: function () {
					loading.stop();
					modal.alert('Błąd dodawania usługi. Prosimy spróbować później', function () {
						broker.trigger('REFRESH_BASKET_VIEW');
					})
				}
			});
		}


		$checkboxes.each(function () {
			const $this = $(this);
			const checked = $this.is(':checked');
			const value = $this.val();
			const currentQuantity = $this.parent().find('.js-partner-service-quantity').val();
			const prevQuantity = checkPrevQuantity(value);
			if (checked && prevQuantity === 0) {
				toAddList.push({ serviceId: value, quantity: currentQuantity })
			} else if (!checked && prevQuantity > 0) {
				toRemoveList.push(value);
			} else if (checked && prevQuantity > 0 && prevQuantity != currentQuantity) {
				toUpdateList.push({ serviceId: value, quantity: currentQuantity })
			}
		});

		loading.start();
		run();
	}

	return {
		load
	};
});
